// Configuration file for API keys and settings
// IMPORTANT: Set environment variables in Netlify for production deployment
// For local development, use .env file
const config = {
  // Google Maps API Key - set via environment variable
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,

  // Strava API credentials
  strava: {
    clientId: process.env.REACT_APP_STRAVA_CLIENT_ID,
    clientSecret: process.env.REACT_APP_STRAVA_CLIENT_SECRET,
    accessToken: process.env.REACT_APP_STRAVA_ACCESS_TOKEN || '08a0040a8a495ca16d2f082dd3550f2433638a80',
    refreshToken: process.env.REACT_APP_STRAVA_REFRESH_TOKEN
  },

  // Google Spreadsheet ID
  spreadsheetId: process.env.REACT_APP_SPREADSHEET_ID || '1WVpQhFTZxoxGptF8mn16eRPOm6OUsm8di5bQ96_90uk',
  
  // Sheet name/range to fetch
  sheetRange: 'Sheet1!A2:T1000', // Adjust based on your sheet structure
  
  // Map configuration
  map: {
    defaultCenter: { lat: 51.5074, lng: -0.1278 }, // London as default
    defaultZoom: 6,
    routeColors: {
      marathon: '#FF5733',
      ultra: '#3357FF',
      road: '#FF33A1',
      trail: '#33FF57'
    }
  },
  
  // Cache settings
  cache: {
    enabled: true,
    expiryDays: 7 // Cache GPX data for 7 days
  }
};

export default config;
